import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'

export const TuileArgument = ({ title, mentions, icon , CTA: { analytics, URL, target }}) => {
   return (
      <a
         href={URL}
         target={target}
         class="tuile-argument lien-composite"
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={analytics.pdbVi}
         data-pdb-ta={analytics.pdbTa}
         data-adv-canal={analytics.advCanal}
         data-adv-cappingdata={analytics.advCappingdata}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
      >
         <span class={`icon icon-${icon}`}></span>
         <h3 class="h4 title m-0 p-0" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
         <span class="mentions m-0 p-0">{mentions}</span>
      </a>
   )
}
